/******************************************************************************
 *** BgtMbsdsAtrzPrgrsInq ** 운영비 * 수입/지출결의서 결재진행 조회
*******************************************************************************/
import React from "react";
import Util from "@/js/common/Util";
import SelectBox from "@/js/common/ui/input/SelectBox";
import StyledTabs from "@/js/common/ui/StyledTabs";
import { Tab, TabList, TabPanel } from "react-tabs";
import * as Atom from "@/js/common/Atom";
import { useRecoilValue } from "recoil";
import TextBox from "@/js/common/ui/input/TextBox";
import BgtMbsdsPrgrsDpstList from "./BgtMbsdsPrgrsDpstList";
import BgtMbsdsPrgrsExpndList from "./BgtMbsdsPrgrsExpndList";

const BgtMbsdsAtrzPrgrsInq = () => {
    const userInfo = useRecoilValue(Atom.userInfo);
    // 검색 조건
    const [upOgnzCd  , setUpOgnzCd ] = React.useState<string>(userInfo.upOgnzCd);      // 상위조직코드(본부)
    const [ognzCd    , setOgnzCd   ] = React.useState<string>(userInfo.ognzCd  );      // 조직코드(지부)
    const [acntgYear , setAcntgYear] = React.useState<string>(Util.getNowAcntgYear()); // 회계연도
    const [searchAtrzSttsCd, setSearchAtrzSttsCd] = React.useState<string>("03"); // 진행상태(검색)
    const [searchKywd      , setSearchKywd      ] = React.useState<string>(""); // 검색어(적요)

    // TAB
    const [tabIndex, setTabIndex] = React.useState<number>(0); // 0: 수입, 1: 지출

    return (
        <div className="w1200 bgcWhite p20 bdrd8 mt10 boxShadowSoft">
            {/* 타이틀 */}
            <div className="mt5">
                <span className="dpBlock w100p fm-c fs25 fc2c3e50 ls1 pb10">운영비 결재진행 조회</span>
                <div className="bdt3 bdc007bff pb10" />
            </div>

            {/* 검색 조건 */}
            <div className="bd1 bdcDDDDDD p20 mb10 bdrd6 bgcFAFAFA">
                <div className="dpFlx aiC flxWrap gap14">
                    {/* 소속 */}
                    <div className="dpFlx aiC">
                        <span className="w50 fm-c fs15 fc333333 ls1 taL">본부</span>
                        <SelectBox value={upOgnzCd}
                            width={150} height={36}
                            fontSize={14} fontFamily="fm-c" color="#333" letterSpacing={-1}
                            borderColor="#ddd" borderOnColor="#222" borderRadius={2}
                            background="#F6F6F6" paddingRight={8}
                            codeArray={Util.getUpOrgCodeArray("01")}
                            placeholder="전체"
                            onChangeFunc={(data: string) => setUpOgnzCd(data)}
                            disabled={true}
                        />
                    </div>

                    {/* 지부 */}
                    <div className="dpFlx aiC">
                        <span className="w50 fm-c fs15 fc333333 ls1 taL">지부</span>
                        <SelectBox value={ognzCd}
                            width={150} height={36}
                            fontSize={14} fontFamily="fm-c" color="#333" letterSpacing={-1}
                            borderColor="#ddd" borderOnColor="#222" borderRadius={2}
                            background="#F6F6F6"
                            codeArray={Util.getDownOrgCodeArray(upOgnzCd)}
                            placeholder="전체" paddingRight={8}
                            onChangeFunc={(data: string) => setOgnzCd(data)}
                            disabled={true}
                        />
                    </div>

                    {/* 회계연도 */}
                    <div className="dpFlx aiC">
                        <span className="w80 fm-c fs15 fc333333 ls1 taL">회계연도</span>
                        <SelectBox value={acntgYear}
                            width={120} height={36}
                            fontSize={14} fontFamily="fm-c" color="#333" letterSpacing={-1}
                            borderColor="#ddd" borderOnColor="#222" borderRadius={2}
                            background="#fff"
                            codeArray={Util.getAcntgYearArray()}
                            placeholder="선택" paddingRight={8}
                            onChangeFunc={(data: string) => setAcntgYear(data)}
                        />
                    </div>

                    {/* 진행상태 */}
                    <div className="dpFlx aiC">
                        <span className="w80 fm-c fs15 fc333333 ls1 taL">진행상태</span>
                        <SelectBox value={searchAtrzSttsCd}
                            width={140} height={36}
                            fontSize={14} fontFamily="fm-c" color="#333" letterSpacing={-1}
                            borderColor="#ddd" borderOnColor="#222" borderRadius={2}
                            background="#fff" paddingRight={8}
                            codeArray={[{ code: "", name: "전체" }].concat(Util.getCodeArray("ATRZ_STTS_CD").filter(item => item.code === '03' || item.code === '05'))}
                            placeholder="전체"
                            onChangeFunc={(data: string) => setSearchAtrzSttsCd(data)}
                        />
                    </div>

                    {/* 적요 */}
                    <div className="dpFlx aiC">
                        <span className="w50 fm-c fs15 fc333333 ls1 taL">적요</span>
                        <TextBox value={searchKywd}
                            width={200} height={36}
                            fontSize={14} fontFamily="fm-c" color="#333" letterSpacing={-1}
                            borderColor="#ddd" borderOnColor="#222" borderRadius={2}
                            style={{ backgroundColor: "#fff", padding: "0 12px" }}
                            placeholder="검색어 입력"
                            onChangeFunc={(text: string) => setSearchKywd(text)}
                        />
                    </div>
                </div>
            </div>

            {/* 탭 */}
            <StyledTabs selectedIndex={tabIndex} className="mb10 tabFit">
                <TabList>
                    <Tab onClick={() => setTabIndex(0)}>수입 결의서 </Tab>
                    <Tab onClick={() => setTabIndex(1)}>지출 결의서</Tab>
                </TabList>

                {/* ========================= 수입 탭 ========================= */}
                <TabPanel>
                    <BgtMbsdsPrgrsDpstList
                        ognzCd           = {ognzCd          } // 조직
                        acntgYear        = {acntgYear       } // 회계연도
                        searchAtrzSttsCd = {searchAtrzSttsCd} // 진행상태
                        searchKywd       = {searchKywd      } // 검색어(적요)
                    ></BgtMbsdsPrgrsDpstList>
                </TabPanel>

                {/* ========================= 지출 탭 ========================= */}
                <TabPanel>
                    <BgtMbsdsPrgrsExpndList
                        ognzCd           = {ognzCd          } // 조직
                        acntgYear        = {acntgYear       } // 회계연도
                        searchAtrzSttsCd = {searchAtrzSttsCd} // 진행상태
                        searchKywd       = {searchKywd      } // 검색어(적요)
                    ></BgtMbsdsPrgrsExpndList>
                </TabPanel>
            </StyledTabs>
        </div>
    );
};

export default BgtMbsdsAtrzPrgrsInq;